import { useState, useEffect, useRef } from 'react';
import {
    Button, Flex, FormControl, FormLabel, Input, Text, VStack,
    Link, FormErrorMessage, UnorderedList, ListItem,
    Collapse,
    useToast,
    Stack
} from '@chakra-ui/react'
import { useForm, Controller } from "react-hook-form";
import { Link as ReactLink, useHistory } from 'react-router-dom'
import {
    BsBoxArrowInDown, BsArrowCounterclockwise
} from "react-icons/bs";
import {
    SelectOffice, SelectLevel, SelectMaritalStatus,
    InputTelephoneNumber, SectionForm, SelectLocationGroup,
    SelectHouseOwner, SelectHouseStatus, SelectResidence,
    CheckboxScanDocument
} from '../shared'
import { getUserInfo } from '../../classes/User'
import { useUserContext } from '../../context/userContext'
import FormRequest, { getFormRequestInfo, postFormRequest, putUpdateFormRequest } from '../../classes/FormRequest';
import { useLoadingContext } from '../../context/loadingContext';
import { toastErrDesc, toastVal } from '../../utils/toastUtils';
// import { errorHandle } from '../../api/api';

const ApplicationForm = ({ fid }) => {
    const [defaultFormValue, setDefaultFormValue] = useState(FormRequest.DEFAULT_FORM_VALUE)
    const { control, handleSubmit, formState: { errors }, watch, reset, setValue, setError } = useForm({ defaultValues: defaultFormValue })
    const { userData } = useUserContext()
    const toast = useToast()
    const { onModalClose, onModalOpen } = useLoadingContext()
    const history = useHistory()
    const [formReqData, setFormReqData] = useState(null)

    const loadUserData = useRef(null)
    loadUserData.current = async () => {
        try {
            const res = await getUserInfo(userData.id, userData.token)
            if (res) {
                // console.log(res)
                const updateDefaultValue = {
                    ...FormRequest.DEFAULT_FORM_VALUE,
                    level: res.level_select,
                    office: res.office_select,
                    requester_first_name: `${res.title}${res.first_name}`, // title + first_name
                    requester_last_name: res.last_name,
                    requester_position_name: res.position,
                    tel: res.tel,
                }
                setDefaultFormValue(updateDefaultValue)
                reset(updateDefaultValue)
            }

        } catch (error) {
            // console.log('error')
            // console.log(errorHandle(error))
            toast(toastVal({
                title: "การดึงข้อมูล ไม่สำเร็จ",
                description: toastErrDesc(error),
                status: "error",
            }))
        }
    }

    const loadData = useRef(null)
    loadData.current = async () => {
        await getFormRequestInfo(fid, userData.token)
            .then(res => {
                // console.log('edit form req id: ' + fid)
                const resFormValue = res.formValue()
                // console.log(resFormValue)
                setFormReqData(resFormValue)
                reset(resFormValue)
            })
            .catch(error => {
                // console.log('error')
                // console.log(errorHandle(error))
                toast(toastVal({
                    title: "การดึงข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }

    useEffect(() => {
        if (fid) {
            loadData.current()
        } else {
            loadUserData.current()
        }
    }, [fid])

    const resetForm = () => {
        reset(defaultFormValue)
    }

    const onSubmit = async (data) => {
        // tel
        data.tel = data.tel?.replaceAll(" ", "").replaceAll("_", "")
        if (data.tel.length !== 10) {
            setError("tel", { type: 'invalid', message: 'รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง' }, { shouldFocus: true })
            return;
        }

        const postData = new FormRequest(data)
        onModalOpen()

        if (formReqData) {
            // update form
            // console.log('update fid: ' + postData.id)
            //putUpdateFormRequest
            await putUpdateFormRequest(postData.id, postData.serialized(), userData.token)
                .then(res => {
                    // console.log(res)
                    onModalClose()
                    resetForm()

                    toast(toastVal({
                        title: "การบันทึกข้อมูลสำเร็จ",
                        description: `บันทึกข้อมูล เรียบร้อยแล้ว`,
                    }))

                    if (res.id) {
                        //redirect
                        history.push(`/form/${res.id}/step2`)
                    }
                })
                .catch(error => {
                    // console.log(error)
                    onModalClose()

                    toast(toastVal({
                        title: "การบันทึกข้อมูล ไม่สำเร็จ",
                        description: toastErrDesc(error),
                        status: "error",
                    }))
                })

        } else {
            // add new form
            await postFormRequest(postData.serialized(), userData.token)
                .then(res => {
                    // console.log(res)
                    onModalClose()
                    resetForm()

                    toast(toastVal({
                        title: "การบันทึกข้อมูลสำเร็จ",
                        description: `บันทึกข้อมูล เรียบร้อยแล้ว`,
                    }))

                    if (res.id) {
                        //redirect
                        history.push(`/form/${res.id}/step2`)
                    }
                })
                .catch(error => {
                    // console.log(error)
                    onModalClose()

                    toast(toastVal({
                        title: "การบันทึกข้อมูล ไม่สำเร็จ",
                        description: toastErrDesc(error),
                        status: "error",
                    }))
                })
        }

    }

    const SpouseInfoForm = () => {
        const maritalStatus = watch("marital_status")

        if (!maritalStatus || maritalStatus?.value === 1) {
            setValue("spouse_full_name", "")
            setValue("spouse_position_name", "")
            setValue("spouse_office_name", "")
            setValue("children", 0)
        }

        return (
            <VStack w="full">
                <Stack w="full" direction={{ base: "column", md: "row" }}>
                    <FormControl isInvalid={errors.spouse_full_name} isRequired={false}>
                        <FormLabel>คู่สมรสชื่อ</FormLabel>
                        <Controller
                            name="spouse_full_name"
                            control={control}
                            rules={{ required: false }}
                            render={({ field }) => <Input type="text" maxLength={240} placeholder="กรอกชื่อคู่สมรส" {...field} />}
                        />
                    </FormControl>
                    <FormControl isInvalid={errors.spouse_position_name} isRequired={false}>
                        <FormLabel>ตำแหน่ง</FormLabel>
                        <Controller
                            name="spouse_position_name"
                            control={control}
                            rules={{ required: false }}
                            render={({ field }) => <Input type="text" maxLength={240} placeholder="กรอกตำแหน่งคู่สมรส" {...field} />}
                        />
                    </FormControl>
                </Stack>
                <Stack w="full" direction={{ base: "column", md: "row" }}>
                    <FormControl isInvalid={errors.spouse_office_name} isRequired={false}>
                        <FormLabel>สถานที่ปฏิบัติงาน</FormLabel>
                        <Controller
                            name="spouse_office_name"
                            control={control}
                            rules={{ required: false }}
                            render={({ field }) => <Input type="text" maxLength={240} placeholder="กรอกชื่อสถานที่ปฏิบัติงานของคู่สมรส" {...field} />}
                        />
                    </FormControl>
                    <FormControl isInvalid={errors.children} isRequired={false}>
                        <FormLabel>มีบุตร จำนวน(คน)</FormLabel>
                        <Controller
                            name="children"
                            control={control}
                            rules={{ required: false, max: 20, min: 0 }}
                            render={({ field }) => <Input type="number" min={0} max={20} placeholder="กรอกจำนวนบุตร" {...field} />}
                        />
                        {errors.children && <FormErrorMessage>กรอกจำนวนบุตรไม่ถูกต้อง</FormErrorMessage>}
                    </FormControl>
                </Stack>
            </VStack>
        )
    }

    return (
        <Flex mt={4} w="full" direction="column">
            <form onSubmit={handleSubmit(onSubmit)} >
                <SectionForm header="ข้อมูลส่วนตัว" >
                    <Stack w="full" direction={{ base: "column", md: "row" }}>
                        <FormControl isInvalid={errors.requester_first_name} isRequired>
                            <FormLabel>ชื่อ</FormLabel>
                            <Controller
                                name="requester_first_name"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => <Input type="text" maxLength={100} placeholder="กรอกชื่อ" {...field} />}
                            />
                        </FormControl>
                        <FormControl isInvalid={errors.requester_last_name} isRequired>
                            <FormLabel>นามสกุล</FormLabel>
                            <Controller name="requester_last_name"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => <Input type="text" maxLength={100} placeholder="กรอกนามสกุล" {...field} />}
                            />
                        </FormControl>
                        <FormControl isInvalid={errors.requester_position_name} isRequired>
                            <FormLabel>ชื่อตำแหน่ง</FormLabel>
                            <Controller name="requester_position_name"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => <Input type="text" maxLength={150} placeholder="กรอกชื่อตำแหน่ง" {...field} />}
                            />
                        </FormControl>
                    </Stack>
                    <Stack w="full" direction={{ base: "column", md: "row" }}>
                        <FormControl isInvalid={errors.level} isRequired>
                            <FormLabel>ระดับ</FormLabel>
                            <SelectLevel control={control} />
                            <FormErrorMessage>กรุณาเลือกระดับ</FormErrorMessage>
                        </FormControl>
                        <FormControl isInvalid={errors.office} isRequired>
                            <FormLabel>หน่วยงาน</FormLabel>
                            <SelectOffice control={control} />
                            <FormErrorMessage>กรุณาเลือกหน่วยงาน</FormErrorMessage>
                        </FormControl>
                        <FormControl isInvalid={errors.tel} isRequired>
                            <FormLabel>หมายเลขโทรศัพท์มือถือ</FormLabel>
                            <InputTelephoneNumber control={control} />
                            <FormErrorMessage>{errors.tel?.message || "กรอกหมายเลขโทรศัพท์ให้ถูกต้อง"}</FormErrorMessage>
                        </FormControl>
                    </Stack>

                </SectionForm>
                <SectionForm header="ข้อมูลสถานะภาพ" >
                    <FormControl isInvalid={errors.marital_status} isRequired>
                        <FormLabel>สถานะภาพ</FormLabel>
                        <SelectMaritalStatus control={control} />
                        {errors.marital_status && <FormErrorMessage>กรุณาเลือกสถานะภาพ</FormErrorMessage>}
                    </FormControl>
                    <Collapse in={watch("marital_status")?.value > 1} style={{ width: '100%' }}>
                        <SpouseInfoForm />
                    </Collapse>

                </SectionForm>
                <SectionForm header="ข้อมูลที่อยู่ในทะเบียนบ้านปัจจุบัน" >
                    <Stack w="full" direction={{ base: "column", md: "row" }}>
                        <FormControl isInvalid={errors.address} isRequired>
                            <FormLabel>ที่อยู่ในทะเบียนบ้านเลขที่</FormLabel>
                            <Controller name="address"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => <Input type="text" maxLength={200} placeholder="กรอกเลขที่บ้าน" {...field} />}
                            />
                        </FormControl>
                        <FormControl isInvalid={errors.soi} isRequired>
                            <FormLabel>ซอย/ถนน</FormLabel>
                            <Controller name="soi"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => <Input type="text" maxLength={200} placeholder="กรอกชื่อซอย/ถนน" {...field} />}
                            />
                        </FormControl>
                    </Stack>
                    <SelectLocationGroup control={control}
                        setValue={setValue}
                        error={errors}
                        province={watch("province")}
                        district={watch("district")} />
                    <Stack w="full" direction={{ base: "column", md: "row" }}>
                        <FormControl isInvalid={errors.house_owner} isRequired>
                            <FormLabel>บ้านดังกล่าวเป็นของ</FormLabel>
                            <SelectHouseOwner control={control} />
                            {errors.house_owner && <FormErrorMessage>กรุณาเลือกเจ้าของบ้าน</FormErrorMessage>}
                        </FormControl>
                        <FormControl isInvalid={errors.house_status} isRequired>
                            <FormLabel>โดยเป็น</FormLabel>
                            <SelectHouseStatus control={control} />
                            {errors.house_status && <FormErrorMessage>กรุณาลักษณะการเป็นเจ้าของ</FormErrorMessage>}
                        </FormControl>
                        <Collapse in={watch("house_status")?.value === 4} style={{ width: '100%' }}>
                            <FormControl isInvalid={errors.house_other_status_name} isRequired={watch("house_status")?.value === 4}>
                                <FormLabel>โดยเป็น (อื่นๆ)</FormLabel>
                                <Controller name="house_other_status_name"
                                    control={control}
                                    rules={{ required: watch("house_status")?.value === 4 }}
                                    render={({ field }) => <Input type="text" maxLength={100} placeholder="กรอกลักษณะอื่นๆ" isDisabled={watch("house_status")?.value !== 4} {...field} />}
                                />
                            </FormControl>
                        </Collapse>
                    </Stack>

                </SectionForm>
                <SectionForm header="ข้อมูลการขอเข้าพักอาศัย" >
                    <FormControl isInvalid={errors.residence} isRequired>
                        <FormLabel>มีความประสงค์ขอเข้าพักอาศัยในอาคารที่พักข้าราชการศาลยุติธรรมในเขตกรุงเทพมหานคร <Text color="red" as="span">(หมายเหตุ 1 คำร้องต่อ 1 อาคาร)</Text></FormLabel>
                        <SelectResidence control={control} />
                        {errors.residence && <FormErrorMessage>กรุณาเลือกอาคารบ้านพักที่ต้องการเข้าอาศัย</FormErrorMessage>}
                    </FormControl>
                </SectionForm>
                {/* <SectionForm header="ผู้บังคับบัญชา" direction="row" >
                    <FormControl isInvalid={errors.head_full_name} isRequired>
                        <FormLabel>ชื่อ-นามสกุลผู้บังคับบัญชา</FormLabel>
                        <Controller name="head_full_name"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => <Input type="text" maxLength={240} placeholder="กรอกชื่อ-นามสกุลของผู้บังคับบัญชา" {...field} />}
                        />
                        {errors.head_full_name && <FormErrorMessage>กรุณากรอกชื่อ-นามสกุลผู้บังคับบัญชา</FormErrorMessage>}
                    </FormControl>
                    <FormControl isInvalid={errors.head_position_name} isRequired>
                        <FormLabel>ตำแหน่งของผู้บังคับบัญชา</FormLabel>
                        <Controller name="head_position_name"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => <Input type="text" maxLength={240} placeholder="กรอกชื่อตำแหน่งของผู้บังคับบัญชา" {...field} />}
                        />
                        {errors.head_position_name && <FormErrorMessage>กรุณากรอกตำแหน่งของผู้บังคับบัญชา</FormErrorMessage>}
                    </FormControl>
                </SectionForm> */}
                <SectionForm header="เอกสารประกอบ">
                    <FormControl>
                        <FormLabel>ทั้งนี้ ได้แนบเอกสารที่เกี่ยวข้องเพื่อประกอบการพิจารณา ดังนี้</FormLabel>
                        <CheckboxScanDocument control={control} watch={watch} />
                    </FormControl>
                    <Collapse in={watch("scan_document_list")?.includes("6")} style={{ width: '100%' }}>
                        <FormControl isInvalid={errors.other_document_name} isRequired={watch("scan_document_list")?.includes("6")}>
                            <FormLabel>ระบุชื่อเอกสารอื่นๆ</FormLabel>
                            <Controller name="other_document_name"
                                control={control}
                                rules={{ required: watch("scan_document_list")?.includes("6") }}
                                render={({ field }) => <Input type="text" maxLength={150} placeholder="กรอกชื่อเอกสารอื่นๆ" isDisabled={!watch("scan_document_list")?.includes("6")} {...field} />}
                            />
                            {errors.other_document_name && <FormErrorMessage>กรุณากรอกระบุชื่อเอกสารอื่นๆ</FormErrorMessage>}
                        </FormControl>
                    </Collapse>
                </SectionForm>

                <SectionForm header="หมายเหตุ" divider={false}>
                    <UnorderedList>
                        <ListItem>1 คำร้อง สามารถเลือกอาคารที่พักได้ 1 อาคาร</ListItem>
                        {/* <ListItem>ผู้บังคับบัญชาต้องเป็น ข้าราชการตั้งแต่ระดับ ชํานาญการขึ้นไป</ListItem> */}
                        <ListItem>กรณีมีบ้านเป็นของตนเอง หรือคู่สมรส หรือบตุรในเขตกรุงเทพมหนครหรือปริมณฑลไม่มีสิทธิเข้าพักอาศัยในอาคารที่พักข้าราชการศาลยุติธรรมในเขตกรุงเทพมหานคร</ListItem>
                    </UnorderedList>
                </SectionForm>
                <VStack w="full" >
                    <Stack w="full" mt={4} direction={{ base: "column", md: "row" }} justify="center">
                        <Button type="submit" colorScheme="blue" fontSize="md" leftIcon={<BsBoxArrowInDown />}>
                            บันทึกข้อมูล
                        </Button>
                        <Button type="reset" colorScheme="yellow" fontSize="md" leftIcon={<BsArrowCounterclockwise />} onClick={resetForm}>
                            ล้างฟอร์ม
                        </Button>
                    </Stack>
                    <Link to="/" as={ReactLink}>
                        <Button fontSize="md" variant="link" mt={4}>
                            กลับหน้าหลัก
                        </Button>
                    </Link>
                </VStack>
            </form>
        </Flex>
    )
}

export default ApplicationForm
